/* eslint-disable no-console */
import { cognitoAxiosInstance } from 'config/axiosInstance'
import convertKeys from 'utils/convert-keys'
import { getToken } from 'services/amplify/auth'
import {
  PROFILE_REWARDS_QUESTIONS,
  ACCOUNT_FULL_UNVEIL,
  ACCOUNT_FULL_UNVEIL_ASSOCIATED_IDS,
  ACCOUNT_FULL_UNVEIL_BREACH_DATA,
  ACCOUNT_FULL_UNVEIL_NOTIFICATION_SUMMARY,
} from 'resources/endpoints'

const fetchProfileRewardsData = async (answerSource) => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(`${PROFILE_REWARDS_QUESTIONS}/`, {
    params: { answer_source: answerSource },
  })
  return convertKeys.toCamel(response.data)
}

const updateProfileRewardsAnswer = async (questionId, requestPayload) => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).put(`${PROFILE_REWARDS_QUESTIONS}/${questionId}/`, requestPayload)
  return convertKeys.toCamel(response.data)
}

const fetchFullUnveil = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(ACCOUNT_FULL_UNVEIL)
  return convertKeys.toCamel(response.data)
}

const updateFullUnveil = async (conflictResolutions, isSkipped) => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).post(ACCOUNT_FULL_UNVEIL, {
    conflict_resolutions: conflictResolutions ? convertKeys.toSnake(conflictResolutions) : null,
    is_skipped: isSkipped,
  })
  return convertKeys.toCamel(response.data)
}

const updateAssociatedIds = async (associatedIds) => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).patch(ACCOUNT_FULL_UNVEIL_ASSOCIATED_IDS, {
    associated_ids: convertKeys.toSnake(associatedIds),
  })
  return convertKeys.toCamel(response.data)
}

const fetchBreachData = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(ACCOUNT_FULL_UNVEIL_BREACH_DATA)
  return convertKeys.toCamel(response.data)
}

const fetchUnveilNotificationSummary = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(ACCOUNT_FULL_UNVEIL_NOTIFICATION_SUMMARY)
  return convertKeys.toCamel(response.data)
}

export default {
  fetchProfileRewardsData,
  updateProfileRewardsAnswer,
  fetchFullUnveil,
  updateFullUnveil,
  updateAssociatedIds,
  fetchBreachData,
  fetchUnveilNotificationSummary,
}
